import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionStore } from '../../constants';
import { useAppSelector } from '../../redux-store/hook';
import { ResponseReuseType } from '../../taskList/constants';
import { Stage } from '../../taskList/interfaces';
import { RRMessageProps } from '../components/layout_01/BasicTaskListLayout';
import { isFrrAppliedOnAllStages } from '../utils/basicStageList';

interface UseBasicResponseReuseReturnType {
  isRRApplied: boolean;
  rrPopupInfo: RRMessageProps;
}
const defaultPopupInfo: RRMessageProps = {
  title: '',
  buttonText: '',
  subtitle1: '',
  subtitle2: '',
  subtitle3: '',
  subtitle4: '',
};

const allFormsCompleted = (): boolean => {
  const companySettingsString = sessionStorage.getItem(SessionStore.companySettings);
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  const companySettings = companySettingsString && JSON.parse(companySettingsString);

  let formsCompleted = true;
  if (formStatus && companySettings) {
    if (
      (!formStatus.applicationFormSubmitted && companySettings.showAppform) ||
      (!formStatus.ofccpSubmitted && companySettings.enableOfccp) ||
      (!formStatus.yourResponsibilitySubmitted && companySettings.showYourResponsiblity) ||
      (!formStatus.eeoSubmitted && companySettings.showEeo) ||
      (!formStatus.researchQuestionSubmitted && companySettings.allowCEBDemographyResearch)
    )
      formsCompleted = false;
  }
  return formsCompleted;
};

export const useBasicResponseReuse = (tasks: Stage[]): UseBasicResponseReuseReturnType => {
  const candidate = useAppSelector((state) => state.candidate);
  const [isRRApplied, setIsRRApplied] = useState<boolean>(false);
  const [rrPopupInfo, setRrPopupInfo] = useState<RRMessageProps>(defaultPopupInfo);
  const { t } = useTranslation();
  useEffect(() => {
    /** update rr message info and rrApplied flag as per the RR applied */
    if (!allFormsCompleted()) setIsRRApplied(false);
    else {
      if (tasks.length) {
        const isFrrOrPrrApplied: boolean = tasks.some(
          (task) =>
            task.responseReuseType === ResponseReuseType.FULL_RR ||
            task.responseReuseType === ResponseReuseType.PARTIAL_RR,
        );

        if (isFrrOrPrrApplied) {
          const frrAppliedOnAllStages = isFrrAppliedOnAllStages(tasks);

          const rrMessageInfo: RRMessageProps = {
            buttonText: t('rrProceedButton'),
            title: t('rrPopupTitle', {
              firstName: candidate?.firstName,
            }),
            subtitle1: t('frrPopupSubTitle1'),
            subtitle2: t('rrPopupSubTitle2'),
            subtitle3: t('rrPopupSubTitle3'),
            subtitle4: t('rrPopupSubTitle4'),
          };

          if (!frrAppliedOnAllStages) {
            rrMessageInfo.subtitle1 = t('prrPopupSubTitle5');
            rrMessageInfo.buttonText = t('gotIt');
          }

          setRrPopupInfo(rrMessageInfo);
          setIsRRApplied(isFrrOrPrrApplied);
        }
      }
    }
  }, [tasks]);

  return { isRRApplied, rrPopupInfo };
};
